import angular from 'angular';
import '../layouts.module';
import template from './main-layout.component.html';
import './main-layout.component.scss';

const MENU_BUTTON_SELECTOR = '.cp-topbar__menu';

class MainLayoutController {
  constructor($transitions, $element, $timeout, AuthService) {
    this.$transitions = $transitions;
    this.AuthService = AuthService;
    this.$element = $element;
    this.$timeout = $timeout;
    this.menuOpen = false;
  }

  $onInit() {
    this.AuthService.fetchProfile().catch(() => null);
    this.removeTransitionHook = this.$transitions.onSuccess({}, () => {
      this.menuOpen = false;
    });
  }

  $onDestroy() {
    this.removeTransitionHook();
  }

  openMenu() {
    this.menuOpen = true;
  }

  closeMenu() {
    if (!this.menuOpen) return;
    this.menuOpen = false;
    this.$timeout(() => {
      const button = this.$element[0].querySelector(MENU_BUTTON_SELECTOR);
      if (button) button.focus();
    });
  }

  handleKeydown(event) {
    if (event.key === 'Escape') this.closeMenu();
  }
}

MainLayoutController.$inject = ['$transitions', '$element', '$timeout', 'AuthService'];

angular.module('app.layouts').component('cpMainLayout', {
  controller: MainLayoutController,
  controllerAs: 'vm',
  template
});
